import React from 'react';
import { getLinkToTab } from '../../../utils';
import { HeaderBar } from './HeaderBar';
import { Project } from '../../../types';
import { ConnectionsApi } from '../../../apis';
import { AuthService } from '../../../services';
import { User } from 'oidc-client';
import { app } from "@microsoft/teams-js";

export interface HeaderProps {
  user: User;
  project: Project;
  connectionId?: string;
  serviceName?: string;
  linkToUrl?: string;
  setTabIsDefault: (value: boolean) => any;
  tabIsDefault: boolean;
}

/**
 * A replacement header for the CONNECT header.
 * Because of our unique situation with authentication and iframes,
 * we've chosen to build our own header and feed in user information.
 *
 * Honestly, this is how the CONNECT header should work. There's no reason
 * it should have its own authentication. It should accept a token and go from there.
 */
export class Header extends React.Component<HeaderProps> {
  constructor(props: HeaderProps) {
    super(props);
    this.setDefaultConnection = this.setDefaultConnection.bind(this);
  }

  async setDefaultConnection(value: boolean) {
    const context = await app.getContext();
    const link = await getLinkToTab(context.entityId);

    if (!this.props.connectionId) return;

    let result: boolean;
    if (value) {
      result = await ConnectionsApi.createDefaultTabForConnections(
        this.props.project.id,
        [this.props.connectionId],
        link
      );
    } else {
      result = await ConnectionsApi.deleteDefaultTabForConnections(
        this.props.project.id,
        [this.props.connectionId]
      );
    }

    if (result) this.props.setTabIsDefault(value);
  }

  render() {
    return (
      <HeaderBar
        user={this.props.user}
        onSignoutClick={async () => AuthService.signout()}
        project={this.props.project}
        serviceName={this.props.serviceName}
        onViewProfileClick={() => window.open(AuthService.getProfileLink())}
        onProjectClick={() => window.open(this.props.linkToUrl)}
        tabIsDefault={this.props.tabIsDefault}
        onSetDefaultConnection={this.setDefaultConnection}
      />
    );
  }
}
